// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
header[data-v-07f1fae4] {
    line-height: 1.5;
}
.logo[data-v-07f1fae4] {
    display: block;
    margin: 0 auto 2rem;
}
@media (min-width: 1024px) {
header[data-v-07f1fae4] {
      display: flex;
      place-items: center;
      padding-right: calc(var(--section-gap) / 2);
}
.logo[data-v-07f1fae4] {
      margin: 0 2rem 0 0;
}
header .wrapper[data-v-07f1fae4] {
      display: flex;
      place-items: flex-start;
      flex-wrap: wrap;
}
}
`, "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":";AAkBE;IACE,gBAAgB;AAClB;AAEA;IACE,cAAc;IACd,mBAAmB;AACrB;AAEA;AACE;MACE,aAAa;MACb,mBAAmB;MACnB,2CAA2C;AAC7C;AAEA;MACE,kBAAkB;AACpB;AAEA;MACE,aAAa;MACb,uBAAuB;MACvB,eAAe;AACjB;AACF","sourcesContent":["<script setup lang=\"ts\">\r\n  import Greeting from './components/Greeting.vue'\r\n  import Trigger from './components/Trigger.vue'\r\n</script>\r\n\r\n<template>\r\n  <header>\r\n    <div class=\"wrapper\">\r\n      <Greeting msg=\"Http Logs to Seq\" />\r\n    </div>\r\n  </header>\r\n\r\n  <main>\r\n    <Trigger />\r\n  </main>\r\n</template>\r\n\r\n<style scoped>\r\n  header {\r\n    line-height: 1.5;\r\n  }\r\n\r\n  .logo {\r\n    display: block;\r\n    margin: 0 auto 2rem;\r\n  }\r\n\r\n  @media (min-width: 1024px) {\r\n    header {\r\n      display: flex;\r\n      place-items: center;\r\n      padding-right: calc(var(--section-gap) / 2);\r\n    }\r\n\r\n    .logo {\r\n      margin: 0 2rem 0 0;\r\n    }\r\n\r\n    header .wrapper {\r\n      display: flex;\r\n      place-items: flex-start;\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
